import { render, staticRenderFns } from "./DialogAddGroup.vue?vue&type=template&id=398c9ef6"
import script from "./DialogAddGroup.vue?vue&type=script&lang=js"
export * from "./DialogAddGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398c9ef6')) {
      api.createRecord('398c9ef6', component.options)
    } else {
      api.reload('398c9ef6', component.options)
    }
    module.hot.accept("./DialogAddGroup.vue?vue&type=template&id=398c9ef6", function () {
      api.rerender('398c9ef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddGroup.vue"
export default component.exports